import React, { Component } from 'react';
import { Typography, CircularProgress } from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ErrorIcon from '@material-ui/icons/Error';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import WarningIcon from '@material-ui/icons/Warning';
import * as adminBillingService from '../../services/admin-billing.service';

/**
 * Banner consolidado da aba "Desprovisionados". Mostra contadores da fila de desprovisionamento
 * do tipo informado (trial / non_trial / ambos).
 *
 * Props:
 *  - contractType: "trial" | "non_trial" (obrigatório pra escopar)
 *  - refreshKey: opcional; ao mudar, recarrega (usado quando o admin clica em "atualizar")
 */
class DeprovisioningStatsBanner extends Component {
    state = { loading: true, stats: null };

    componentDidMount() { this.load(); }
    componentDidUpdate(prev) { if (prev.refreshKey !== this.props.refreshKey) this.load(); }

    load = () => {
        this.setState({ loading: true });
        adminBillingService.getDeprovisioningQueueStats(this.props.contractType)
            .then(r => {
                if (r.data.success) this.setState({ loading: false, stats: r.data.data });
                else this.setState({ loading: false });
            })
            .catch(() => this.setState({ loading: false }));
    }

    render() {
        const { loading, stats } = this.state;

        if (loading) {
            return (
                <div style={{ padding: 12, marginBottom: 12, backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: 6, textAlign: 'center' }}>
                    <CircularProgress size={18} />
                </div>
            );
        }

        if (!stats || (stats.pendingtotal === 0 && stats.failedtotal === 0 && stats.droppedlast30days === 0)) {
            return (
                <div style={{ padding: 10, marginBottom: 12, backgroundColor: '#f1f8e9', borderLeft: '3px solid #689f38', borderRadius: 4, fontSize: 12, color: '#33691e' }}>
                    Nenhum desprovisionamento pendente, falha ou drop recente.
                </div>
            );
        }

        const stat = (icon, value, label, color) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderRadius: 6, backgroundColor: '#fff', border: `1px solid ${color}33`, minWidth: 140 }}>
                {React.cloneElement(icon, { style: { color, fontSize: 22 } })}
                <div>
                    <Typography variant="h6" style={{ fontWeight: 700, fontSize: 18, lineHeight: 1, color }}>{value}</Typography>
                    <Typography variant="caption" style={{ color: '#616161', fontSize: 11, display: 'block' }}>{label}</Typography>
                </div>
            </div>
        );

        return (
            <div style={{ padding: 12, marginBottom: 12, backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: 8 }}>
                <Typography variant="caption" style={{ color: '#757575', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11 }}>
                    Resumo da fila de desprovisionamento
                </Typography>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
                    {stat(<ScheduleIcon />, stats.pendingtotal, 'Aguardando drop', '#ef6c00')}
                    {stats.pendingnext3days > 0 && stat(<WarningIcon />, stats.pendingnext3days, 'Nos próximos 3 dias', '#c62828')}
                    {stats.pendingnext7days > stats.pendingnext3days && stat(<ScheduleIcon />, stats.pendingnext7days, 'Nos próximos 7 dias', '#f9a825')}
                    {stats.failedtotal > 0 && stat(<ErrorIcon />, stats.failedtotal, 'Com falha (requer atenção)', '#b71c1c')}
                    {stats.droppedlast30days > 0 && stat(<DeleteForeverIcon />, stats.droppedlast30days, 'Deletados últimos 30d', '#424242')}
                </div>
            </div>
        );
    }
}

export default DeprovisioningStatsBanner;
